import { LAYOUTS, } from "@voltmoney/types";
import { InputStateToken, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { closeModalAction, DisbursalVerifyAction, goBack, saveEmailId, textOnChange, toggleCTA } from "./actions";
import { needHelp } from "../../login/phone_number/actions";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
import { isGoogleLoginEnabled } from "../../../configs/uri-config-utils";
import { getContactUsDetails } from "../../../configs/utils";
import { api } from "../../../configs/api";
export const template = (applicationId, setIsUserLoggedIn, enableGoogleLogin, isFromPhonePe, height, contactUsDetails, preFilledEmailId, isFromJupiter) => {
    return {
        layout: {
            id: ROUTE.ENTER_EMAIL,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true,
            },
            widgets: [
                { id: 'enterEmailScreen', type: WIDGET.ENTER_EMAIL_PAGE },
            ],
        },
        datastore: {
            enterEmailScreen: {
                height,
                needHelpAction: {
                    routeId: ROUTE.ENTER_EMAIL,
                    type: ACTION.NEED_HELP,
                    payload: { id: 'bt_verifyEmailScreen_needHelp' }
                },
                goBackAction: {
                    routeId: ROUTE.ENTER_EMAIL,
                    type: ACTION.BACK,
                    payload: { id: 'bt_verifyEmailScreen_goBack' }
                },
                action: {
                    type: ACTION.VERIFY_OTP,
                    payload: {
                        value: "",
                    },
                    routeId: ROUTE.ENTER_EMAIL,
                },
                continueAction: {
                    type: ACTION.CONTINUE,
                    payload: {
                        widgetId: "enterEmailScreen",
                        applicationId,
                        setIsUserLoggedIn,
                    },
                    routeId: ROUTE.ENTER_EMAIL,
                },
                errorAction: {
                    type: ACTION.DISABLE_CONTINUE,
                    routeId: ROUTE.ENTER_EMAIL,
                    payload: {
                        value: false,
                        targetWidgetId: "enterEmailScreen",
                    },
                },
                successAction: {
                    type: ACTION.ENABLE_CONTINUE,
                    routeId: ROUTE.ENTER_EMAIL,
                    payload: {
                        value: true,
                        targetWidgetId: "enterEmailScreen",
                    },
                },
                closeModalAction: {
                    routeId: ROUTE.ENTER_EMAIL,
                    type: ACTION.CLOSE_MODAL_ACTION,
                    payload: {}
                },
                isDisabled: true,
                numberOfOtp: 6,
                email: "",
                state: InputStateToken.DEFAULT,
                caption: { error: "" },
                otpLimitExceeded: false,
                counter: 0,
                showErrorModal: false,
                contactUsDetails,
                extraSpace: 18,
                preFilledEmail: preFilledEmailId,
                isFromJupiter: isFromJupiter
            },
        },
    };
};
export const emailMF = {
    onLoad: async ({ getHeight, instrumentTrack, network }, { applicationId, setIsUserLoggedIn, }) => {
        instrumentTrack("ENTER_EMAIL_PAGE_VIEWED");
        const user = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        const enableGoogleLogin = isGoogleLoginEnabled(user);
        const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
        applicationId = (await SharedPropsService.getUser())
            .linkedBorrowerAccounts[0].accountId;
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const response = await network
            .get(`${api.userProfile}${accountId}`, {
            headers: await getAppHeader(),
        })
            .then(response => response.data)
            .catch(error => console.log('error', error));
        const preFilledEmailId = response.emailId;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        return Promise.resolve(template(applicationId, setIsUserLoggedIn, enableGoogleLogin, isFromPhonePe, getHeight(), contactUsDetails, preFilledEmailId, isFromJupiter));
    },
    actions: {
        [ACTION.BACK]: goBack,
        [ACTION.CONTINUE]: saveEmailId,
        [ACTION.ENTER_EMAIL]: textOnChange,
        [ACTION.ENABLE_CONTINUE]: toggleCTA,
        [ACTION.DISABLE_CONTINUE]: toggleCTA,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.VERIFY_OTP]: DisbursalVerifyAction,
        [ACTION.CLOSE_MODAL_ACTION]: closeModalAction,
    },
};
